// extracted by mini-css-extract-plugin
var _1 = "RentalPortalListingsBoardSkeleton-moduleRentalPortalListingsBoardSkeleton__I0c0u";
var _2 = "RentalPortalListingsBoardSkeleton-modulebody__STd88";
var _3 = "RentalPortalListingsBoardSkeleton-modulecover__PkJW2 Skeleton-moduleSkeleton__Mlrfv";
var _4 = "RentalPortalListingsBoardSkeleton-modulemeta__q56Mx Skeleton-moduleSkeleton__Mlrfv";
var _5 = "RentalPortalListingsBoardSkeleton-moduletitle__zpJrM Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "RentalPortalListingsBoardSkeleton", _2 as "body", _3 as "cover", _4 as "meta", _5 as "title" }
